export function createObjectivesMethods(api) {
    return {
        async listObjectives(campaignId) {
            const {data} = await api.gamemasterCampaignsObjectivesRetrieve(campaignId);
            return data;
        },

        /**
         * @param {string} campaignId
         * @param {{name: string, description?: string}} objective
         */
        async createObjective(campaignId, objective) {
            const {data} = await api.gamemasterCampaignsObjectivesCreate(campaignId, objective);
            return data;
        },
    };
}
